export const site = {
  shortName: 'tkasparaitis.io',

  fullName: 'Tomas Kasparaitis',

  headline: 'Software engineer and hardware enthusiast based in Columbus, Ohio.',

  pitch: [
    "A customized Linux platform with Rust apps that test real hardware, packaged with Tauri + Electron. My main focus is disk health, erasure (low-level commands per governing-body docs), and verification, both pattern-based and forensic. Also included in the platform are ways to test GPUs (compute & consumer), memory and CPUs.",
    "Isn't that a solved problem? Yes, it is... but most vendor tools lack cohesion to do it all in one place, features we need and easy integration with our systems. And then there's turnaround time on simple features that we can ship in days, not months or years.",
  ],

  location: 'Columbus, Ohio',

  avatar: '/photos/avatar.jpg',

  email: 'tkasparaitis@gmail.com',

  links: [
    { label: 'GitHub',   href: 'https://github.com/t-kasparaitis' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/tkasparaitis' },
    { label: 'Email',    href: 'mailto:tkasparaitis@gmail.com' },
  ],

  copyright: `© ${new Date().getFullYear()} Tomas Kasparaitis`,
} as const;
